<template>
    <!-- 项目案例 -->
    <section class="indBlock titLeft">
        <div class="container">
            <div class="hd clearfix">
                <h3><a href="#">项目案例</a></h3>
                <div class="introTxt">高品质项目案例展示</div>
                <div class="more"><a class="btn hoverBg" href="#" v-if="false">查看案例</a></div>
            </div>
            <div class="bd">
                <ul class="pList">
                    <li>
                        <div class="icon"><i class="icons-msgBox"></i></div>
                        <div class="tit">智慧信访大数据</div>
                        <div class="link">
                            <a class="btn whiteSty" href="#" @click="showDetail('http://www.tipdm.com/zhxfdsj/index.jhtml')">查看案例</a>
                            <router-link to="/projectApplication"><a class="btn whiteLineSty" href="#">申请服务</a></router-link>
                        </div>
                    </li>
                    <li>
                        <div class="icon"><i class="icons-drainage"></i></div>
                        <div class="tit">工业废水处理</div>
                        <div class="link">
                            <a class="btn whiteSty" href="#" @click="showDetail('http://www.tipdm.com/gyfscl/index.jhtml')">查看案例</a>
                            <router-link to="/projectApplication"><a class="btn whiteLineSty" href="#">申请服务</a></router-link>
                        </div>
                    </li>
                    <li>
                        <div class="icon"><i class="icons-cloudMonitoring"></i></div>
                        <div class="tit">沼气远程监控</div>
                        <div class="link">
                            <a class="btn whiteSty" href="#" @click="showDetail('http://www.tipdm.com/zqycjk/index.jhtml')">查看案例</a>
                            <router-link to="/projectApplication"><a class="btn whiteLineSty" href="#">申请服务</a></router-link>
                        </div>
                    </li>
                    <li>
                        <div class="icon"><i class="icons-truck"></i></div>
                        <div class="tit">道路运输安全</div>
                        <div class="link">
                            <a class="btn whiteSty" href="#" @click="showDetail('http://www.tipdm.com/dlysaq/index.jhtml')">查看案例</a>
                            <router-link to="/projectApplication"><a class="btn whiteLineSty" href="#">申请服务</a></router-link>
                        </div>
                    </li>
                    <li>
                        <div class="icon"><i class="icons-tv"></i></div>
                        <div class="tit">广电用户服务</div>
                        <div class="link">
                            <a class="btn whiteSty" href="#" @click="showDetail('http://www.tipdm.com/gdyhfwdsj/index.jhtml')">查看案例</a>
                            <router-link to="/projectApplication"><a class="btn whiteLineSty" href="#">申请服务</a></router-link>
                        </div>
                    </li>
                    <li>
                        <div class="icon"><i class="icons-electric"></i></div>
                        <div class="tit">电力大数据应用</div>
                        <div class="link">
                            <a class="btn whiteSty" href="#" @click="showDetail('http://www.tipdm.com/dldsjyy/index.jhtml')">查看案例</a>
                            <router-link to="/projectApplication"><a class="btn whiteLineSty" href="#">申请服务</a></router-link>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        methods:{
            showDetail(uri){
                window.open(uri)
            }
        }
    };
</script>